import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  agency;
  login;
  department;
  user;
  partner;
  legal;
  isERC;
  isSub;
  isAgency;
  label;
  email;

  get permission() {
    return this.parent.permission;
  }

  init(data) {
    this.agency = data.AgencyId;
    this.login = data.Login;
    this.isERC = data.IsReservationCenter;
    this.isSub = data.IsSubAgent;
    this.isAgency = !data.IsSettingEnabled;
    this.email = data.Email || '';
    this.department = data.DepartmentId
      ? {
        value: data.DepartmentId,
        label: data.DepartmentName,
      }
      : null;
    this.user = {
      value: data.MasterAgentUserId,
      label: data.FullName,
    };
    this.partner = {
      value: data.PartnerId,
      label: data.PartnerName,
    };
    this.legal = {
      value: data.LegalEntityId,
      label: data.LegalEntityName,
    };
    if (data.FullName) {
      this.label = data.FullName
        .split(' ')
        .reduce((acc, item, i) => {
          if (!item) {
            return acc;
          }
          if (i === 0) {
            return item;
          }
          return `${acc} ${item[[0]]}.`;
        }, '');
    }
  }

  logout() {
    return this.parent.authentication.logout();
  }
}
